import { i18n } from "@lingui/core";
// src/i18n/effects.ts
const activateLocaleMessages = (localeId, messages) => {
	if (i18n.locale !== localeId) i18n.loadAndActivate({
		locale: localeId,
		messages
	});
};
export { activateLocaleMessages };

//# sourceMappingURL=effects.js.map